import axiosService from "./AxiosService.js";

const fournisseursService = {
  getFournisseursAutocomplete(extraitNom) {
    return axiosService.get(`/fournisseurs/search?q=${extraitNom}`);
  },
  getFournisseurs(recherche, page) {
    let url = `/fournisseurs/publies?q=${recherche}`;
    if (page) {
      url += `&pageIndex=${page}`;
    }
    return axiosService.get(url);
  },
  getFournisseur(id) {
    return axiosService.get(`/fournisseurs/publies/${id}`);
  },
};
export default fournisseursService;
